import { createFeatureSelector, createSelector } from '@ngrx/store';
import { informationFeatureKey, State } from 'src/app/reducers/information.reducer';

const selectInformationState = createFeatureSelector<State>(informationFeatureKey);

export const getInformations = createSelector(selectInformationState, state => state.getInformationsResult);
export const getNewInformation = createSelector(selectInformationState, state => state.newInformation);
